
  import { defineComponent, inject } from "vue";
  import { mapStores } from "pinia";

  import { get } from "lodash";
  import { marked } from "marked";

  import { useMasterLayoutStore } from "@/stores/MasterLayoutStore";
  import BaseProcessComponentV2 from "@/components/processComponents/v2/BaseProcessComponentV2.vue";
  import VueTable from "@/components/VueTable.vue";
  import { ContextKeys } from "@/enums/contextKeys.enum";
  import { Events } from "@/enums/events.enum";

  interface Section {
    title: string;
    subtitle?: string;
    headers: string[];
    rows: string[];
  }

  export default defineComponent({
    name: "QuoteResultsRendererV2",

    setup(props: any) {
      const root: string = props.path.split(".")[0];

      return {
        [root]: inject(root),
      };
    },

    data() {
      return {
        fileGenerationRequest: {
          id: null,
          files: {
            target: null,
          },
        },
      };
    },

    components: { VueTable },

    extends: BaseProcessComponentV2,

    computed: {
      ...mapStores(useMasterLayoutStore),

      sections(): Section[] {
        const sections = (this.value || []) as Section[];

        return JSON.parse(JSON.stringify(sections), (_: string, value: any): any => {
          if (typeof value === "string") {
            return marked.parse(value);
          }

          return value;
        });
      },
    },

    methods: {
      async executePreviewAction({ action, context = {} }: { action: any; context?: any }) {
        const tabTarget = get(action, "settings.tabTarget", "_blank");
        const presignedUrl = get(context, get(action, "settings.source"));

        window.open(presignedUrl, tabTarget);
      },

      async download(): Promise<void> {
        this.masterLayoutStore.toggleSpinner();
        await this.processEvent({
          events: this.resolvedClientSideEvents,
          eventName: `$this.${Events.DOWNLOAD}`,
          context: {
            [ContextKeys.APPLICATION]: this.applicationStore.application,
            [ContextKeys.THIS]: this,
          },
        });
        this.masterLayoutStore.toggleSpinner();
      },
    }
  });
